import { Fragment } from "react";
import { object, string } from "prop-types";
import { observer } from "mobx-react";
import { HtmlParser } from "@utils";
import { useEstimateEditorStore, useEstimateTableSettings, useVisibilityModeCellClassName } from "@tools";
import { TooltipIcon } from "@components";
import { Divider } from "@material-ui/core";
import classnames from "classnames";
import useStyle from "./TaskDescriptionTooltip.style";
import { useTranslation } from "react-i18next";

export const TaskDescriptionTooltip = observer(({
  element,
  lighterColor
}) => {
  const { t } = useTranslation();
  const { visibilityMode } = useEstimateEditorStore();
  const { descriptionColumns, allDescriptionColumnsHidden } = useEstimateTableSettings();
  const classes = useStyle();
  
  const { descriptions, hasDescriptions } = element;
  
  const className = useVisibilityModeCellClassName(allDescriptionColumnsHidden);
  const columnsWithDescriptions = descriptionColumns
    .filter(c => (visibilityMode ? !c.hide : c.isVisible) && hasDescriptions[c.descriptionId]);

  if (!columnsWithDescriptions.length)
    return <></>;
  
  return (
    <TooltipIcon
      color="primary"
      className={classnames(
        "button-description-view noDrag preset-taskActionButton",
        lighterColor,
        className
      )}
      interactive={ true }
      tooltipClassName={classnames("ql-root", classes.contentTooltip)}
      disabled={!!className}
    >
      {
        columnsWithDescriptions
          .map(({ descriptionId, displayName }, index, l) => (
            <Fragment key={descriptionId}>
              { index > 0 && <Divider className="bg-secondary my-1 transparent-1" /> }
              {
                l.length > 1 &&
                <strong className="py-1 mb-1 text-sm w-full">{ displayName || t("common.desc") }</strong>
              }
              { HtmlParser(descriptions?.get(descriptionId)?.content) }
            </Fragment>
          ))
      }
    </TooltipIcon>
  )
});

TaskDescriptionTooltip.propTypes = {
  element: object.isRequired,
  lighterColor: string,
};
